module.exports = {
    UPGRADE: 'MEMBER_UPGRADE',
    ENTRANCE: 'ENTRANCE_FEE',
    ADVERTISEMENTS: 'ADVERTISEMENT'
}